import { create } from 'zustand';
import {
  ClientInfoCreateModel,
  ClientInfoFilter,
  ClientInfoModel,
  ClientInfoUpdateModel,
} from '../model/clitent-model';
import axiosInstance from '../../../configs/axios';
import { ClientChildrenModel } from '../data/client-modal-child';
import { RoleInfoModel } from '../../role/model/role.model';
import { PositionModel } from '../../position/model/position.model';
import { MinistryModel, ProvinceModel } from '../../documents/models/destination.model';
import { DepartmentModel } from '../../department/model/department.model';
import { axiosErrorMessage } from '../../../utils/error-message';
import { AxiosError } from 'axios';
import { ApiPath } from '../../../constants/apiPath';
import CusttomAlertController from '../../../alert/controller/custom.alert.controller';
import { CustomAlertType } from '../../../alert/data/custom.alert.type';
import { CustomAlertIcons } from '../../../alert/data/custom.alert.icon';
export interface ClientControllerState {
  listUser: ClientInfoModel[] | [];
  listCount: number;
  message: string | null;
  loading: boolean;
  filter: ClientInfoFilter | null;
  page: number;
  pageRowAmount: number;
  activeModal: ClientChildrenModel | null;
  formCreate: ClientInfoCreateModel | null;
  formUpdate: ClientInfoUpdateModel | null;
  originalFormUpdate: ClientInfoUpdateModel | null;
  listRoles: RoleInfoModel[];
  listPosition: PositionModel[];
  listProvince: ProvinceModel[];
  listMinistry: MinistryModel[];
  listDepartment: DepartmentModel[];
  createdByName: string | null;
  selectedItem: ClientInfoModel | null;
}

export interface ClientControllerAction {
  clientGetData: (startLoading?: boolean, filter?: ClientInfoFilter | null) => void;
  onPageChange: (page: number, rows: number) => void;
  onFilterChange: (filter?: ClientInfoFilter | null) => void;
  onHandleModal: (activeModal?: ClientChildrenModel | null) => void;
  onUpdateFormCreate: (form: ClientInfoCreateModel | null) => void;
  onUpdateFormUpdate: (form: ClientInfoUpdateModel | null) => void;
  onSubmitForm: (form: ClientInfoCreateModel | null) => void;
  onSubmitFormUpdate: (form: ClientInfoUpdateModel | null) => void;
  onDelete: (id: string) => void;
  getRoles: () => void;
  getPosition: () => void;
  getProvince: () => void;
  getMinistry: () => void;
  getDepartment: () => void;
  getStaff: (uuid: string) => void;
  setSelectedItem: (user: ClientInfoModel) => void;
}
export const ClientController = create<ClientControllerState & ClientControllerAction>()((set) => ({
  loading: true,
  listUser: [],
  message: null,
  listCount: 0,
  page: 0,
  pageRowAmount: 10,
  filter: { skip: 0, take: 10 },
  activeModal: null,
  formCreate: null,
  formUpdate: null,
  originalFormUpdate: null,
  listRoles: [],
  listPosition: [],
  listProvince: [],
  listMinistry: [],
  listDepartment: [],
  createdByName: null,
  selectedItem: null,
  clientGetData: async (startLoading?: boolean, filter?: ClientInfoFilter | null) => {
    try {
      if (startLoading) set(() => ({ loading: true }));
      var finalParams = { ...filter, skip: filter?.skip ?? 0, take: filter?.take ?? 10 };
      delete finalParams?.positionData;
      delete finalParams?.ministryData;
      delete finalParams?.provinceData;
      delete finalParams?.departmentData;
      const res = await axiosInstance.get(ApiPath.appUsers.all, { params: finalParams });
      const filteredData: any = res?.data?.data ?? [];

      const filteredDataTotal: any = res?.data?.meta?.total ?? 0;
      set(() => ({ listUser: filteredData, listCount: filteredDataTotal }));
    } catch (error) {
      set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
    } finally {
      if (startLoading) setTimeout(() => set(() => ({ loading: false })), 500);
    }
  },
  onPageChange: (page: number, rows: number) => {
    set(() => ({ pageRowAmount: rows, page: page }));
  },
  onFilterChange(filter?: ClientInfoFilter | null) {
    set(() => ({ filter: filter }));
    this.clientGetData(true, filter);
  },
  onHandleModal: (activeModal?: ClientChildrenModel | null) => {
    set(() => ({ activeModal: activeModal, message: null }));
    if (activeModal === null) {
      set(() => ({ formCreate: null, formUpdate: null, originalFormUpdate: null }));
    }
  },
  onUpdateFormCreate: (form: ClientInfoCreateModel | null) => {
    set(() => ({ formCreate: form, message: null }));
  },
  onUpdateFormUpdate: (form: ClientInfoUpdateModel | null) => {
    set((state) => ({
      formUpdate: form,
      message: null,
      originalFormUpdate: state.originalFormUpdate ?? form,
    }));
  },
  async onSubmitForm(form: ClientInfoCreateModel | null) {
    if (!form) return;
    try {
      set(() => ({ loading: true, message: null }));
      form.user_position_id = form.position_id;
      const res = await axiosInstance.post(ApiPath.appUsers.create, form);
      if (res?.status === 200 || res?.status === 201) {
        set(() => ({ message: null, formCreate: null, filter: null, page: 0, loading: false }));
        this.clientGetData(true, null);
        this.onHandleModal(null);
        CusttomAlertController.getState().handleCustomAlert({
          title: 'ສຳເລັດ',
          message: 'ເພີ່ມຜູ້ໃຊ້ງານແອັບສຳເລັດແລ້ວ',
          type: CustomAlertType.SUCCESS,
          icon: CustomAlertIcons.successCircle,
        });
      } else {
        set(() => ({ message: res?.statusText }));
      }
    } catch (error) {
      set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
    } finally {
      set(() => ({ loading: false }));
    }
  },
  async onSubmitFormUpdate(form: ClientInfoUpdateModel | null) {
    if (!form) return;
    try {
      set(() => ({ loading: true, message: null }));
      const original = ClientController.getState().originalFormUpdate;
      const changedFields: Record<string, unknown> = {};
      for (const key of Object.keys(form) as (keyof ClientInfoUpdateModel)[]) {
        if (key === 'id') continue;
        if (form[key] !== original?.[key]) changedFields[key] = form[key];
      }
      const res = await axiosInstance.patch(ApiPath.appUsers.update(form.id!), changedFields);
      if (res?.status === 200) {
        set(() => ({
          message: null,
          formUpdate: null,
          originalFormUpdate: null,
          filter: null,
          page: 0,
        }));
        this.clientGetData(true, null);
        setTimeout(() => this.onHandleModal(null), 500);
        CusttomAlertController.getState().handleCustomAlert({
          title: 'ສຳເລັດ',
          message: 'ແກ້ໄຂຜູ້ໃຊ້ງານແອັບສຳເລັດແລ້ວ',
          type: CustomAlertType.SUCCESS,
          icon: CustomAlertIcons.successCircle,
        });
      } else {
        set(() => ({ message: res?.statusText }));
      }
    } catch (error) {
      set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
    } finally {
      setTimeout(() => set(() => ({ loading: false })), 500);
    }
  },
  async onDelete(id: string) {
    try {
      set(() => ({ loading: true }));
      const res = await axiosInstance.delete(ApiPath.appUsers.delete(id));

      if (res?.status === 200) {
        this.clientGetData(true, null);
      } else {
        set(() => ({ message: res?.statusText }));
      }
    } catch (error) {
      set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
    } finally {
      setTimeout(() => set(() => ({ loading: false })), 500);
    }
  },
  getRoles: async () => {
    try {
      const res = await axiosInstance.get(ApiPath.roles.all, { params: { skip: 0, take: 100 } });
      const filteredData: any = res?.data?.data ?? [];

      set(() => ({ listRoles: filteredData }));
    } catch (error) {
      set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
    }
  },
  getPosition: async () => {
    try {
      const res = await axiosInstance.get(ApiPath.positions.all, {
        params: { skip: 0, take: 100 },
      });
      const filteredData: any = res?.data.data ?? [];
      set(() => ({ listPosition: filteredData }));
    } catch (error) {
      set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
    }
  },
  getProvince: async () => {
    try {
      const res = await axiosInstance.get(ApiPath.provinces.all, {
        params: { skip: 0, take: 100 },
      });
      const filteredData: any = res?.data?.data ?? [];
      set(() => ({ listProvince: filteredData }));
    } catch (error) {
      set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
    }
  },
  getMinistry: async () => {
    try {
      const res = await axiosInstance.get(ApiPath.ministries.all, {
        params: { skip: 0, take: 100 },
      });
      const filteredData: any = res?.data?.data ?? [];
      set(() => ({ listMinistry: filteredData }));
    } catch (error) {
      set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
    }
  },
  getDepartment: async () => {
    try {
      const res = await axiosInstance.get(ApiPath.departments.all, {
        params: { skip: 0, take: 100 },
      });
      const filteredData: any = res?.data?.data ?? [];
      set(() => ({ listDepartment: filteredData }));
    } catch (error) {
      set(() => ({ message: axiosErrorMessage({ error: error as AxiosError }) }));
    }
  },
  getStaff: async (uuid: string) => {
    try {
      set(() => ({ createdByName: null }));
      const res = await axiosInstance.get(ApiPath.webappUsers.findOne(uuid));
      const data = res?.data;
      const fullName = `${data?.first_name ?? ''} ${data?.last_name ?? ''}`.trim();
      set(() => ({ createdByName: fullName || uuid }));
    } catch {
      set(() => ({ createdByName: uuid }));
    }
  },
  setSelectedItem: (user: ClientInfoModel) => {
    set(() => ({ selectedItem: user }));
  },
}));

export default ClientController;
